<template>
  <div class="main">
    <h1>&#176; {{ local_thermometer.type }}</h1>
    <div class="main-thermometer">
      <div class="thermo-part">
        <div
          class="thermo-border"
          :style="`border: 1px solid ${local_thermometer.styles.border_color}`"
        ></div>
        <div v-for="sec in NumberOfSections" :key="`THERMOSEC${sec}`">
          <div
            :style="
              `border: 1px solid ${local_thermometer.styles.border_color};border-bottom: 0.5`
            "
            class="thermosec"
          >
            <div
              v-for="l in local_thermometer.num_lines"
              :key="`LINES${sec}${l}`"
              class="num-line"
              :style="
                `height: ${heightOfDivider()}px;background-color: ${checkIfColored(
                  sec,
                  l
                )}`
              "
            >
              <div
                class="size-divider"
                :style="
                  `border-bottom: 1px solid ${
                    local_thermometer.styles.border_color
                  };height: ${heightOfDivider()}px`
                "
              ></div>
            </div>
            <div
              class="num-line"
              :style="
                `border: 0px solid black;height: ${heightOfDivider()}px;background-color: ${checkIfColored(
                  sec,
                  local_thermometer.num_lines + 1
                )}`
              "
            ></div>
          </div>
        </div>
        <div
          class="thermo-bulb"
          :style="
            `background: ${local_thermometer.styles.bg_color}; border: 1px solid ${local_thermometer.styles.border_color}`
          "
        ></div>
      </div>
      <div class="numbering-part" v-if="Numbering().length > 0">
        <span
          :style="`top: ${19 + 30 * num_index}px`"
          v-for="(num, num_index) in Numbering()"
          :key="`NUMBS${num}`"
          >{{ num }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "design1",
  props: {
    thermometer: {
      type: Object,
    },
  },
  data() {
    return {
      local_thermometer: this.thermometer,
    };
  },
  methods: {
    formatLineNumber() {
      const start = this.local_thermometer.start;
      const end = this.local_thermometer.end;
      const new_stepsize =
        this.local_thermometer.stepsize /
        (this.local_thermometer.num_lines + 1);

      let a = [];

      for (let i = start; i <= end; i += new_stepsize) {
        a.push(i);
      }

      const find = this.local_thermometer.fill_upto;
      let count = 0;
      for (let i = 0; i < a.length; i++) {
        if (parseFloat(a[i].toFixed(4)) === parseFloat(find)) {
          return count;
        }
        count++;
      }
    },
    calcLineNumber(sec, l) {
      const num_lines = this.local_thermometer.num_lines;
      let line_number = (sec - 1) * (num_lines + 1);
      line_number = line_number + l;
      return line_number;
    },
    checkIfColored(sec, l) {
      const id = this.calcLineNumber(sec, l);
      const num_lines = this.local_thermometer.num_lines + 1;
      const num_sec = this.NumberOfSections;
      const num_rows = num_lines * num_sec;
      let reversing_sec = num_rows - id + 1;

      let new_fill_upto = this.formatLineNumber();

      if (reversing_sec <= new_fill_upto) {
        return this.local_thermometer.styles.bg_color;
      } else {
        return "white";
      }
    },
    Numbering() {
      const start = this.local_thermometer.start;
      const end = this.local_thermometer.end;
      const stepsize = this.local_thermometer.stepsize;
      let a = [];

      for (let i = start; i <= end; i += stepsize) {
        a.push(i);
      }
      a.reverse();
      return a;
    },
    heightOfDivider() {
      const num_lines = this.thermometer.num_lines;
      const height_sec = 30;
      return height_sec / (num_lines + 1);
    },
  },
  computed: {
    NumberOfSections() {
      const a = this.Numbering();
      return a.length - 1;
    },
  },
  watch: {
    local_thermometer: {
      handler: function(new_val) {
        if (new_val.start == "") {
          this.local_thermometer.start = 0;
        }
        if (new_val.end == "") {
          this.local_thermometer.end = 0;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.main-thermometer {
  display: flex;
  position: relative;
  gap: 5px;
}
.thermosec {
  position: relative;
  height: 30px;
  width: 30px;
  border: 1px solid black;
  z-index: 999;
}
.numbering-part span {
  position: absolute;
  font-weight: 700;
  font-size: 0.9rem;
}
.num-line {
  position: relative;
  width: 100%;
  z-index: 30;
}
.thermo-border {
  position: relative;
  top: 15px;
  width: 30px;
  height: 30px;
  border: 1px solid black;
  border-radius: 50%;
  /* Halve the circle */
  border-bottom-color: transparent;
  border-left-color: transparent;
  /* Rotate the circle */
  transform: rotate(-45deg);
  background: white;
}
.thermo-bulb {
  position: relative;
  top: -9px;
  left: -4px;
  height: 38px;
  width: 38px;
  border: 1px solid black;
  border-radius: 50%;
  z-index: 998;
}
.size-divider {
  position: absolute;
  width: 20px;
  z-index: -30;
  left: 9px;
}
</style>
